/*
 * HdPanel.tsx Simuliert ein fluent-ui "Panel" mit einem Mui "Drawer"
 *
 * Created by Dr. Maximillian Dornseif 2023-11-13 in huWaWi3 33.8.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import React, { ReactElement, useCallback, useState } from 'react'

import { HdCloseIcon } from '../../lib/components/HdIcons'

interface IDialogReturn {
  openDialog: () => void
  dismissDialog: () => void
  isDialogOpen: boolean
  // renderDialog: anya
  renderDialog: ({ renderBody, renderActions }: { renderBody: () => ReactElement }) => ReactElement
}

export function useHdPanel(title: string, description?: string): IDialogReturn {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

  const openDialog = useCallback(() => {
    setIsDialogOpen(true)
  }, [setIsDialogOpen])
  const dismissDialog = useCallback(() => {
    setIsDialogOpen(false)
  }, [setIsDialogOpen])

  const renderDialog = ({ renderBody, renderActions }) => (
    <Drawer
      anchor={'right'}
      open={isDialogOpen}
      onClose={dismissDialog}
      PaperProps={{ sx: { scroll: 'body', minWidth: '50%', height:"100%" } }}
    >
      <Box sx={{ m: '1em', height:"100%"  }}>
        <IconButton
          onClick={dismissDialog}
          sx={{
            position: 'absolute',
            right: '0.25em',
            top: '0.25em',
            color: 'gray',
          }}
        >
          <HdCloseIcon />
        </IconButton>

        <Typography variant="h4" component="h3">
          {title}
        </Typography>

        {description ? <Box sx={{ mb: '1em', fontWeight: 'bold' }}>{description}</Box> : null}
        {renderBody() || null}
      </Box>
    </Drawer>
  )

  return { openDialog, renderDialog, isDialogOpen, dismissDialog }
}
